import styled from 'styled-components';

export const StyledCompanyFeed = styled('div')`
  margin-left: -${({ theme }) => theme.x1spacePx}px;
  margin-right: -${({ theme }) => theme.x1spacePx}px;
`;
